<template>
  <div id="app">
    <div class="component-wrap" v-if="stationData">
      <transition name="comp-anim">
        <component
          v-if="loaded == 2"
          :is="currentComponent"
          :userData="userData"
          :stationData="stationData"
          @navigate="navigate">
        </component>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Intro from './components/Intro.vue';
import AudioIntro from './components/AudioIntro.vue';
import Confirmation from './components/Confirmation.vue';
import Evaluation from './components/Evaluation.vue';
import Finale from './components/Finale.vue';
import Newsletter from './components/Newsletter.vue';
import i18n from './i18n';

import './assets/scss/_global.scss';

export default {
  name: 'app',
  data: () => {
    return {
      currentComponent: 'Confirmation',
      lang: 'de',
      stationData: {},
      userData: {},
      userId: 1,
      loaded: 0
    }
  },
  components: {
    Intro,
    AudioIntro,
    Confirmation,
    Evaluation,
    Finale,
    Newsletter
  },
  mounted() {
    if(new URL(window.location.href).searchParams.get('visitor')) {
      this.userId = new URL(window.location.href).searchParams.get('visitor');
    }
    if(!window.apiUrl) {
      window.apiUrl = 'https://lasauge.bird-song.ch';
      // window.apiUrl = 'http://ne01-backend-local.test';
    }
    if(!window.cmsUrl) {
      window.cmsUrl = 'https://wp.ls.bird-song.ch';
    }

    if(!window.cmsSlug) {
      window.cmsSlug = 'offboarding-station';
    }

    const lang = new URL(window.location.href).searchParams.get('lang') || 'de';
    i18n.locale = lang;
    
    this.loadData();
  },
  methods: {
    navigate(view) {
      this.currentComponent = view;
    },
    loadData() {
      const lang = new URL(window.location.href).searchParams.get('lang') || 'de';
      const wpUrl = `${window.cmsUrl}/wp-json/wp/v2/stations?slug=${window.cmsSlug}&lang=${i18n.locale}`
      
      axios.get(wpUrl)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.stationData = response.data[0];
            this.loaded++;
          } else {
            this.stationData = null;
            this.loaded++;
          }
        });
      axios.get(window.apiUrl + '/api/visitors/' + this.userId)
        .then((response) => {
          this.userData = response.data;
          this.loaded++;
        });
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/fonts';
@import './assets/scss/helpers';

#app {
  font-family: 'GT Sectra', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;

  &::after, &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  &::after {
    height: 700%;
    background: linear-gradient(180deg, #ABEADD, #B4EFCE, #B6DCF5, #DDC6E8, #F9C2B8, #F7D3AD, #FBEBA1);
    background-size: 100%;
    transform: translateY(0);
    will-change: transform;
    animation: bggradient 30s linear infinite;
    z-index: 0;
  }
}

.component-wrap {
  z-index: 2;
  position: relative;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@keyframes bggradient { 
  0%{ transform: translateY(0); }
  50%{ transform: translateY(-85%); }
  100%{ transform: translateY(0); }
}

.comp-anim-enter-active {
  transition: opacity 1s $easeOutQuint, transform 1s $easeOutQuint;
}
.comp-anim-leave-active {
  transition: opacity 1s $easeOutQuint, transform 1s $easeOutQuint;
}
.comp-anim-enter, .comp-anim-leave-to {
  opacity: 1;
}
.comp-anim-leave-to {
  transform: translateX(-100%);
}
.comp-anim-enter {
  transform: translateX(100%);
}
</style>
